<div class="relative">
  <button [routerLink]="['/auctions', this.auctionId(), 'checkout']" class="px-2 py-2 !text-[var(--p-info-500)]">
    @if (showCount()) {
      @if (useExtendedDisplay()) {
        <div class="flex justify-center items-center gap-2">
          <fa-icon [icon]="icons.faShoppingCart" [class]="iconClass()" />
          <span>My Cart</span>
          <p-badge badgeSize="small" [value]="elementsInCart()"></p-badge>
        </div>
      } @else {
        <p-overlaybadge [value]="elementsInCart()">
          <fa-icon [icon]="icons.faShoppingCart" [class]="iconClass()" />
        </p-overlaybadge>
      }
    } @else {
      @if (useExtendedDisplay()) {
        <div class="flex justify-center items-center gap-2">
          <fa-icon [icon]="icons.faShoppingCart" [class]="iconClass()" />
          <span>My Cart</span>
        </div>
      } @else {
        <fa-icon [icon]="icons.faShoppingCart" [class]="iconClass()" />
      }
    }
  </button>
  
  @if (isCartOpen()) {
    <div class="absolute top-[125%] left-[calc(100%-300px)] w-[300px] border-2 border-[var(--p-info-500)] bg-white">
      <div class="relative">
        @if (showCount()) {
          <table>
            <thead>
              <tr>
                <th>Item</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              @for (item of cart().lineItems; track $index) {
                <tr>
                  <td>
                    <p>ItemId: {{item.id}}</p>
                  </td>
                  <td>
                    <p>Quantity: {{item.quantity}}</p>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
        <button [routerLink]="['/auctions', this.auctionId(), 'checkout']" 
                class="m-2 bg-[var(--p-primary-500)] hover:bg-[var(--p-primary-600)] active:bg-[var(--p-primary-700)] rounded-2xl px-4 py-2 !text-[var(--p-text-color-primary)]">
          Checkout
        </button>
      </div>
    </div>
  }
</div>